<template>
      
 <div class="container-model-wedding">
      <h3 class="title-themes">Lista de Casamento Hellen e Wellington</h3>

      <h4 class="subtitlewidding">Para nós, a maior alegria é compartilhar este momento especial com vocês. Estamos montando nosso novo lar com muito amor e carinho. Se desejarem nos presentear, preparamos uma lista com itens que sonhamos em ter em nossa casa. Muito obrigado por fazerem parte da nossa história!</h4>

<div class="container-case-flex-wedding">



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden = !isHidden">
        <div class="itens-case">
          <img src="@/assets/wedding/Liquidificador-Portátil-Oster.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Liquidificador Portátil Power Blender Inox Oster </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 237,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


        <transition name="bounce">

          <div v-if='isHidden'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </div>
        </transition>


</div>


</div>


<div class="container-case-flex bw-image">


    <div class="case-flex "  v-on:click="isHidden1 = !isHidden1">
        <div class="itens-case">
          <img src="@/assets/wedding/geladeira-brastemp.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Geladeira Inteligente B= Smart Brastemp Frost Free Inverse
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 4.800,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden1'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex ">


    <div class="case-flex "  v-on:click="isHidden3 = !isHidden3">
        <div class="itens-case">
          <img src="@/assets/wedding/MaquinadeLavar-Brastemp-15Kg.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Máquina de Lavar Brastemp 15Kg BWF15AB</p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 1.940,00 </a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden3'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>






<div class="container-case-flex">

    <div class="case-flex "  v-on:click="isHidden4 = !isHidden4">
        <div class="itens-case">
          <img src="@/assets/wedding/JogodeBanhoKarstenFioPenteado-Lumina-Branco.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Jogo de Banho Karsten Fio Penteado 5 Peças Lumina Branco/ Cinza
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 322,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


        <transition name="bounce">

          <p v-if='isHidden4'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>

</div>


</div>











</div>



















<div class="container-case-flex-wedding">



<div class="container-case-flex ">


    <div class="case-flex "  v-on:click="isHidden5 = !isHidden5">
        <div class="itens-case">
          <img src="@/assets/wedding/Micro-ondas-Brastemp-32 Litros.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Micro-ondas Brastemp 32 Litros Cor Cinza
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 679,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden5'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>


<div class="container-case-flex ">


    <div class="case-flex "  v-on:click="isHidden6 = !isHidden6">
        <div class="itens-case">
          <img src="@/assets/wedding/tv-lg-50.jpeg">

        </div>
        <div class="itens-case-text">
            <p class="">Smart TV 4K LG QNED AI QNED70 de 50 polegadas 2025</p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 2.470,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden6'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden7 = !isHidden7">
        <div class="itens-case">
          <img src="@/assets/wedding/JogodeCamaQueen200Fios.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Jogo de Cama Queen 200 Fios 100% Algodão Eva</p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 490,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden7'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>







<div class="container-case-flex">

    <div class="case-flex "  v-on:click="isHidden8 = !isHidden8">
        <div class="itens-case">
          <img src="@/assets/wedding/Sanduicheira-Inox-Multiuso-Oster.png">

        </div>
        <div class="itens-case-text">
            <p class="">Sanduicheira Inox Multiuso Oster
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 199,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden8'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>


</div>









<div class="container-case-flex-wedding">


<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden9 = !isHidden9">
        <div class="itens-case">
          <img src="@/assets/wedding/FaqueiroTramontina.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Faqueiro Tramontina Pacific em Aço Inox com Facas para Churrasco Acabamento Alto Brilho com Detalhes no Cabo 72 Peças </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 494,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden9'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex  bw-image">


    <div class="case-flex "  v-on:click="isHidden10 = !isHidden10">
        <div class="itens-case">
          <img src="@/assets/wedding/Ferro-vapor-oster.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Passadeira a Vapor Portátil Power Oster </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 199,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden10'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden11 = !isHidden11">
        <div class="itens-case">
          <img src="@/assets/wedding/Fritadeira-Oven-Fryer-Oster.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Fritadeira Oven Fryer 12L Oster Multi </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 494,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden11'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">



    <div class="case-flex "  v-on:click="isHidden12 = !isHidden12">
        <div class="itens-case">
          <img src="@/assets/wedding/lg-ar-12000.avif">

        </div>
        <div class="itens-case-text">
            <p class="">Ar-Condicionado LG AI Dual Inverter

 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 2.790,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden8'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>








</div>












<div class="container-case-flex-wedding">


<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden13 = !isHidden13">
        <div class="itens-case">
          <img src="@/assets/wedding/Lava-Loucas-10-Brastemp.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Lava-Louças 10 Serviços Brastemp Cor Inox </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 3.840,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden13'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden14 = !isHidden14">
        <div class="itens-case">
          <img src="@/assets/wedding/Liquidificador-Oster.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Liquidificador New Osterizer Aço Escovado Oster </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 629,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden14'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden15 = !isHidden15">
        <div class="itens-case">
          <img src="@/assets/wedding/FacaTramontina.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Faca Butcher Tramontina Nômade com Lâmina em Aço Inox</p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 280,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden15'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">



    <div class="case-flex "  v-on:click="isHidden16 = !isHidden16">
        <div class="itens-case">
          <img src="@/assets/wedding/AparelhodeJantar30.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Aparelho de Jantar e Chá 30 Peças Mendi Marfim
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 590,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden16'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>








</div>














<div class="container-case-flex-wedding">


<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden17 = !isHidden17">
        <div class="itens-case">
          <img src="@/assets/wedding/FrigideiraTramontinaProfessional.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Frigideira Tramontina Professional Rasa em Aço Inox Fundo Triplo </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 370,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden17'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden18 = !isHidden18">
        <div class="itens-case">
          <img src="@/assets/wedding/JogodeBanhoKarstenBranco.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Jogo de Banho Karsten Fio Penteado 5 Peças Imperial Branco </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 250,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden18'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden19 = !isHidden19">
        <div class="itens-case">
          <img src="@/assets/wedding/JogoPanelasTramontina.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Jogo de Panelas Tramontina Solar em Aço Inox com Fundo Triplo e Tampas de Inox 6 Peças </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 854,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden19'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">



    <div class="case-flex "  v-on:click="isHidden20 = !isHidden20">
        <div class="itens-case">
          <img src="@/assets/wedding/KitPromocionalCristal.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Kit Linha Taças em Cristal Bohemia Sommelier para Vinho Tinto </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 560,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden20'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>








</div>









<div class="container-case-flex-wedding">


<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden21 = !isHidden21">
        <div class="itens-case">
          <img src="@/assets/wedding/KitChurrascoTramontina.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Kit para Churrasco Tramontina com Lâminas em Aço Inox e Cabos em Madeira 15 Peças
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 695,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden21'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden22 = !isHidden22">
        <div class="itens-case">
          <img src="@/assets/wedding/CafeteiraOster.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Cafeteira Oster Inox Compacta </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 150,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden22'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden23 = !isHidden23">
        <div class="itens-case">
          <img src="@/assets/wedding/VentiladorWAP.png">

        </div>
        <div class="itens-case-text">
            <p class="">Ventilador 50 cm 8 Pás WAP Flow Turbo </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 270,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden23'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">



    <div class="case-flex "  v-on:click="isHidden24 = !isHidden24">
        <div class="itens-case">
          <img src="@/assets/wedding/RoboAspiradorWap.png">

        </div>
        <div class="itens-case-text">
            <p class="">Robô Aspirador de Pó WAP Robot W90 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 550,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden24'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>








</div>













<div class="container-case-flex-wedding">


<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden25 = !isHidden25">
        <div class="itens-case">
          <img src="@/assets/wedding/PurificadorElectrolux.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Purificador Electrolux Eletrônico Compacto Efficient Painel Digital
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 499,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
       <transition name="bounce">

          <p v-if='isHidden25'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden26 = !isHidden26">
        <div class="itens-case">
          <img src="@/assets/wedding/FacaButcherTramontina.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Faca para Carne Butcher Tramontina com Lâmina em Aço Inox e Cabo em Madeira </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 110,00</a>
        </div>
        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden26'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>



<div class="container-case-flex">


    <div class="case-flex "  v-on:click="isHidden27 = !isHidden27">
        <div class="itens-case">
          <img src="@/assets/wedding/RackKappesberg.webp">

        </div>
        <div class="itens-case-text">
            <p class="">Rack Kappesberg 3 Portas Canela </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 525,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden27'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>
</div>




<div class="container-case-flex">



    <div class="case-flex "  v-on:click="isHidden28 = !isHidden28">
        <div class="itens-case">
          <img src="@/assets/wedding/AparelhodeJantarTramontinaAzzura.jpg">

        </div>
        <div class="itens-case-text">
            <p class="">Aparelho de Jantar Tramontina Azzura em Porcelana Decorada 20 Peças
 </p>
        </div>
        <div class="itens-case-button-doc">
                                  
          <a class="button">R$ 520,00</a>
        </div>

        <div class="itens-case-button">
          <a class="button">Presentear</a>
        </div>


      
        <transition name="bounce">

          <p v-if='isHidden28'>
            <img class="pix-hellen" src="@/assets/wedding/helle-pix-bradesco.png"></img>
          </p>
        </transition>


</div>


</div>








</div>








<div class="footer-wedding">

</div>















   




</div>



</template>



<script>
import { Carousel, Slide } from 'vue-carousel';


export default {
  components: {
    Carousel,
    Slide
  },

  
  
data(){
        return{ 
        isHidden: false, isHidden1: false, isHidden2: false, isHidden3: false,  isHidden4: false,  isHidden5: false,  isHidden6: false,  isHidden7: false,isHidden8: false,isHidden9: false,isHidden10: false,
        sbuTitle: false,  sbuTitle1: false, sbuTitle2: false,  sbuTitle3: false,sbuTitle4: false, sbuTitle5: false, sbuTitle6: false, sbuTitle7: false, sbuTitle8: false, sbuTitle9 : false, sbuTitle10: false,
		sbuTitle11: false, sbuTitle12: false, sbuTitle13: false, sbuTitle14: false,sbuTitle15: false, sbuTitle16: false,
        isHidden18: false,  isHidden19: false,  isHidden20: false,  isHidden21: false,  isHidden22: false,  isHidden23: false,  isHidden24: false, isHidden25: false, isHidden26: false, isHidden27: false,  isHidden28: false,
        isHidden29: false,isHidden30: false,isHidden31: false,isHidden32: false,
     sbuTitle17: false, sbuTitle18: false, sbuTitle19: false, sbuTitle20: false,isHidden11: false,
         sbuTitle21: false, sbuTitle22: false ,sbuTitle23: false,isHidden20: false, sbuTitle24:false,sbuTitle25:false
		}
    },


 methods: {
   
   handleScroll: function( el) {
    let a = el.offsetTop 
    let b = window.innerHeight
    let c = window.pageYOffset 

    if (a < b + c ) {
       // el.setAttribute("style", " transform: translate3d(0, -10px, 0); ")
        el.setAttribute("style", " opacity: 1;")
    }
    
    }
  }
};
</script>

<style scoped>

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}


h4.subtitlewidding{
  text-align: center;
    font-size: 22px;
    font-weight: 300;
    color: #777777;
}

.footer-wedding{
  width: 100%;
  height: 200px;
}

.bw-image{
    filter: grayscale(100%);
  /* For older Safari compatibility */
  -webkit-filter: grayscale(100%); 
  
}

img.pix-hellen{
  width: 100%;

}
.container-case-flex-wedding{
  display: flex;
  justify-content: space-between;
}

.container-model-wedding{
    width: 100%;
}
.itens{
  position: relative;
  background: #2157ec;
  font-size: 24px;
  text-align: center;
  height: 400px;
  width: 100%
}

.itens2{
  position: relative;
  background: #ec3f21;
  font-size: 24px;
  text-align: center;
  height: 400px;
  width: 100%
}


p{
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 30px;
  margin-top: 30px;
  color: #020202cf;
}

.hero3 {
    width: 100%;
    height: 600px;
    background-image: url('~@/assets/cases/themes-mamd-cases-gio.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 30px;

}


.hero {
    width: 100%;
  
  

}


.hero img{
    width: 100%;

}

.title-themes{
  margin-bottom: 5px;
  margin-top: 110px;
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
  color: #585858;
  font-size: 38px;
}

.model-flex {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.itens-model-flex {
  margin: 20px 20px;
  width: 30%;
  height: 478px;
}

.container-case-flex{
 display: flex;
 justify-content: space-around;
  margin-bottom: 80px;
}
.case-flex{
 display: flex;
 flex-direction: column;
 justify-content: space-around;
  padding: 20px;
  
}

.itens-case img{
  width: 100%;
}

.itens-case-button-doc{
   display: flex;
    align-items: center;
    justify-content: center;
}

.itens-case-button-doc svg{
   width: 22px;
   height: 22px;
   fill: #020202cf;
}

.itens-case-button-doc a{
 text-decoration: none;
    font-size: 24px;
    font-weight: 700;
    color: #020202cf;
    cursor: pointer;

}


.itens-case-button{
    text-align: center;
    padding: 14px;
    
}
.itens-case-button a{
    width: 100%;
    border: none;
    text-decoration: none;
    height: 30px;
    font-size: 15px;
    padding: 10px 80px;
    border-radius: 4px;
    background-color: #496e4c;
   
    color: rgb(255, 255, 255);
    margin: 10px;
    cursor: pointer;
}

@media (max-width: 1024px) {
  .itens-model-flex {
    height: 300px;
  }
}

/*tablet panoramico*/
@media (max-width: 900px) {
  .itens-model-flex {
    height: 464px;
    width: inherit;

  }
  .model-3 {
  padding-bottom: 40px;
}

}
/*mobile*/
@media (max-width: 599px) {
  .model-flex {
    align-items: center;
    flex-direction: column;
  }

  .title-themes {
font-size: 26px;
  }

  .container-case-flex-wedding{
    flex-wrap: wrap;
  }

  .case-flex{
  padding: 4px;
  width: 100%;
  }

  .itens-model-flex {
    width: inherit;
    height: 468px;
  }

  .itens-case-button a{
        padding: 10px 40px;
  }

  .container-case-flex{
  flex-direction: row;
  align-items: center;
          width: 50%;
  }
}

</style> 
 
 
 
 